<!--
/*
 * This file is part of peacohrm Inc
 *
 * Copyright (C) 2020 onwards peacohrm Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <path
    class="st0"
    d="M 250 0 C 387.99 0 500 112.01 500 250 C 500 387.99 387.99 500 250 500 C 112.01 500 0 387.99 0 250 C 0 112.01 112.01 0 250 0 Z M 205.964 383.006 C 316.585 383.006 377.042 291.34 377.042 211.928 C 377.042 209.314 377.042 206.699 376.879 204.167 C 388.562 195.67 398.856 185.049 406.944 172.957 C 396.242 177.696 384.64 180.964 372.386 182.435 C 384.886 174.918 394.363 163.235 398.856 149.101 C 387.255 155.964 374.428 160.948 360.703 163.725 C 349.755 152.042 334.15 144.771 316.83 144.771 C 283.66 144.771 256.699 171.732 256.699 204.902 C 256.699 209.64 257.189 214.216 258.333 218.627 C 208.333 216.095 164.052 192.157 134.395 155.801 C 129.248 164.624 126.307 175 126.307 185.948 C 126.307 206.781 136.928 225.245 153.105 235.948 C 143.219 235.703 133.987 232.925 125.899 228.431 L 125.899 229.167 C 125.899 258.333 146.569 282.516 174.183 288.154 C 169.199 289.542 163.807 290.278 158.333 290.278 C 154.493 290.278 150.735 289.869 146.977 289.134 C 154.575 313.072 176.797 330.392 203.105 330.882 C 182.516 346.977 156.618 356.536 128.431 356.536 C 123.529 356.536 118.791 356.291 114.052 355.637 C 140.359 372.957 172.059 383.006 205.964 383.006 Z"
  />
</template>
